import { memo } from 'react';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI components
import { Button, Icon } from '@geneui/components';
// Import Context
import { useModalActionsContext } from 'context/modalActionsContext';
// Import Constants
import { l, ReportTypesLabels } from 'constants/common';

interface Props {
    itemData?: AnyObject;
    type?: number;
    title?: string;
    isClearable?: boolean;
    shouldShowInfoModal?: boolean;
    onClear?: () => void;
}

const ReportItemView: React.FC<Props> = ({ itemData, type, title, isClearable, shouldShowInfoModal, onClear }) => {
    const { t } = useTranslation();
    const { modalActionsRef } = useModalActionsContext();

    return (
        <div className="drop-here">
            {type === ReportTypesLabels.Report && (
                <Icon type="icon bc-icon-crm-standart-report crm-object-type-icon dynamic" />
            )}

            <div>
                <div className="drop-here-title">
                    <span>
                        {t(l.Title)}
                        {':'}
                    </span>
                    <p>{title}</p>
                </div>

                <div className="drop-here-title">
                    <span>
                        {t(l.Type)}
                        {':'}
                    </span>
                    <p>{t(ReportTypesLabels[type ?? ''])}</p>
                </div>
                <div className="drop-here-actions">
                    {shouldShowInfoModal && !isNil(itemData) && (
                        <Button
                            color="primary"
                            appearance="minimal"
                            icon="bc-icon-info"
                            onClick={() => modalActionsRef?.current?.onInfoModalOpen?.(itemData)}
                        />
                    )}
                    {isClearable && (
                        <Button color="primary" appearance="minimal" icon="bc-icon-clear" onClick={onClear} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default memo(ReportItemView);
